




















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import GCompetencyDistribution from '@/components/GCompetencyDistribution.vue';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GLoading from '@/components/GLoading.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GStudentAllCompetencyDistribution from '@/views/GStudentAllCompetencyChart/GStudentAllCompetencyDistribution.vue';
import GStudentAllCompetencyGrowthChart from '@/views/GStudentAllCompetencyChart/GStudentAllCompetencyGrowthChart.vue';
import GStudentAllCompetencyFunChart from '@/views/GStudentAllCompetencyChart/GStudentAllCompetencyFunChart.vue';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { Student } from '@/models/student/student';
import { studentModule } from '@/store/modules/entities/student.module';
import { GEnum } from '@/constants/enum.defination';
import { GetStudentRequest } from '@/models/student/get-student-request';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { CompetencyDistributionRequest } from '@/models/competency/competency-distribution-request';
import GStudentAllCompetencyComparison from '@/views/GStudentAllCompetencyChart/GStudentAllCompetencyComparison.vue';

@Component({
  name: 'GStudentAllCompetencyChart',
  components: {
    GStudentAllCompetencyComparison,
    GStudentAllCompetencyGrowthChart,
    GStudentAllCompetencyFunChart,
    GStudentAllCompetencyDistribution,
    GCompetencyLabel,
    GCustomBreadCrumb,
    GCompetencyDistribution,
    GLoading,
  },
  computed: {},
  methods: {},
})
export default class GStudentAllCompetencyChart extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  currentTab: GEnum.AllCompetencyGraphTab = GEnum.AllCompetencyGraphTab.TabDistributionChart;
  studentID: number = 0;
  lazy: boolean = false; // 以前のデータをリセット後にタブ内部を描画

  created() {
    this.studentID = parseInt(this.$route.params.studentID);
    studentAllCompetencyModule.clean();
    this.lazy = true;
  }

  async mounted() {
    await studentModule.getStudent({ studentID: this.studentID } as GetStudentRequest);
    this.breadCrumbItems = [
      { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' },
      { title: this.student.fullName, routerPath: `/pages/student-record/${this.studentID}` },
      { title: this.$t('ALL_COMPETENCY_RESULT').toString() },
    ];
    await studentAllCompetencyModule.fetchStudentCompetencyDistributions({
      studentID: this.studentID,
      targetType: GEnum.TargetType.Class,
      targetID: this.student.schoolClass.schoolClassID,
    } as CompetencyDistributionRequest);
    this.currentTab = GEnum.AllCompetencyGraphTab.TabDistributionChart;
    await studentAllCompetencyModule.fetchstudentCompetencyGrowth(this.studentID);
    // await studentModule.fetchStudentCompetencyData(this.studentID);
  }

  get student(): Student {
    return studentModule.student;
  }

  get isTabDistributionChart(): boolean {
    return this.currentTab === GEnum.AllCompetencyGraphTab.TabDistributionChart;
  }
  get isTabGrowthChart(): boolean {
    return this.currentTab === GEnum.AllCompetencyGraphTab.TabGrowthChart;
  }
  get isTabFunChart(): boolean {
    return this.currentTab === GEnum.AllCompetencyGraphTab.TabFunChart;
  }
  get isTabCompareScore(): boolean {
    return this.currentTab === GEnum.AllCompetencyGraphTab.TabCompareScore;
  }

  handleSelectedTab(tabNum: number) {
    this.currentTab = tabNum;
  }
}
